module.exports = __webpack_public_path__ + "fonts/Roboto-ThinItalic.f476452e.woff2";